import Hero from "../components/sections/Hero";
import BeforeAfterCarousel from "../components/sections/BeforeAfterCarousel";
import ServicesGrid from "../components/sections/ServicesGrid";
import Process from "../components/sections/Process";
import WhyUs from "../components/sections/WhyUs";
import Quiz from "../components/sections/Quiz";
import LeadForm from "../components/sections/LeadForm";
import FAQ from "../components/sections/FAQ";
import ContactSection from "../components/sections/ContactSection";
import FinalCTA from "../components/sections/FinalCTA";
import useSEO from "../lib/useSEO";
import { FAQS } from "../lib/site-data";

export default function Home() {
    useSEO({
        title: "İstanbul Dövme Silme | Pico Lazer & Fraksiyonel CO2 - Doğuş Çizikoğlu",
        description:
            "Pico lazer dövme silme, cover-up öncesi açtırma ve Fraksiyonel CO2 lazer ile iz görünümü değerlendirmesi. Esenyurt İstanbul'da Doğuş Çizikoğlu eşliğinde kişisel ön değerlendirme.",
        canonical: "https://www.istanbuldovmesilme.com/",
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQS.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
        },
    });

    return (
        <>
            <Hero />
            <BeforeAfterCarousel />
            <ServicesGrid />
            <Process />
            <WhyUs />
            <Quiz />
            <LeadForm />
            <FAQ />
            <ContactSection />
            <FinalCTA />
        </>
    );
}
